import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import topSearchingCountriesFormat from 'lumen/helpers/top-searching-countries-format';

interface HotelMarketInsightTooltipsTooltipBlockSearchesSignature {
  Args: {
    searchSummary: unknown;
  };
}

const HotelMarketInsightTooltipsTooltipBlockSearches = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="card-summary">
    <p
      class="card-summary__header text-200--bold"
      data-test-id="tooltip-block-searches-header"
    >{{@searchSummary.searchSummaryTitle}}</p>
    <div class="card-summary__content flex justify-between">
      <p class="metric-title">{{t
          "market_insight.search_patterns.search_level"
        }}</p>
      <div class="flex items-center justify-center truncate">
        <p
          class="metric-value text-200--bold"
          data-test-id="tooltip-block-searches-num-searches"
        >
          {{@searchSummary.numSearchesAsLabel}}
        </p>
      </div>
    </div>

    {{#unless @searchSummary.isHotelBusinessSearchSummary}}
      <div class="card-summary__content flex justify-between">
        <p class="metric-title">{{t
            "market_insight.top_searching_countries"
          }}</p>
        <div class="flex items-center justify-center truncate">
          <p
            class="metric-value text-200--bold"
            data-test-id="tooltip-block-searches-top-countries"
          >
            {{topSearchingCountriesFormat @searchSummary.topCountries}}
          </p>
        </div>
      </div>
    {{/unless}}

    <div class="card-summary__content flex justify-between">
      <p class="metric-title">{{t
          "market_insight.flight_patterns.most_searched_los"
        }}</p>
      <div class="flex items-center justify-center truncate">
        <p
          class="metric-value text-200--bold"
          data-test-id="tooltip-block-searches-most-searched-los"
        >
          {{@searchSummary.formattedMostSearchedLos}}
        </p>
      </div>
    </div>
  </div>
</template> satisfies TOC<HotelMarketInsightTooltipsTooltipBlockSearchesSignature>;

export default HotelMarketInsightTooltipsTooltipBlockSearches;
